import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Experience', path: '/experience' },
  { name: 'Projects', path: '/projects' },
  { name: 'Education', path: '/education' },
  { name: 'Skills', path: '/skills' },
  { name: 'Achievements', path: '/achievements' },
  { name: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setIsOpen(false); }, [location]);
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50,
      borderBottom: '1px solid #e5e5e5',
      background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(12px)',
    }}>
      <div style={{
        maxWidth: 960, margin: '0 auto', display: 'flex',
        alignItems: 'center', justifyContent: 'space-between',
        padding: '16px 24px',
      }}>
        <Link to="/" style={{
          fontFamily: "'Playfair Display', serif", fontSize: '1.25rem',
          fontWeight: 600, color: '#0a0a0a', textDecoration: 'none', letterSpacing: '-0.02em',
        }}>
          Nikhil Savita
        </Link>

        {/* Desktop nav */}
        <nav style={{ display: 'flex', alignItems: 'center', gap: '2rem' }} className="desktop-nav">
          {navLinks.map((link) => (
            <Link key={link.name} to={link.path} style={{
              fontSize: '0.8125rem', letterSpacing: '0.05em', textDecoration: 'none',
              color: location.pathname === link.path ? '#0a0a0a' : '#737373',
              fontWeight: location.pathname === link.path ? 500 : 400,
              transition: 'color 0.2s',
            }}>
              {link.name}
            </Link>
          ))}
        </nav>

        <a href="/resume/Nikhil_Savita_Resume.pdf" target="_blank" rel="noopener noreferrer"
          className="desktop-nav" style={{
            border: '1px solid #0a0a0a', background: '#0a0a0a', color: '#fafafa',
            padding: '8px 16px', fontSize: '0.6875rem', fontWeight: 500,
            textTransform: 'uppercase', letterSpacing: '0.15em', textDecoration: 'none',
          }}>
          Resume
        </a>

        <button onClick={() => setIsOpen(!isOpen)} className="mobile-menu-btn" style={{
          background: 'none', border: 'none', color: '#0a0a0a', cursor: 'pointer', padding: 4,
        }}>
          {isOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div style={{
          position: 'fixed', inset: 0, top: 57, background: 'rgba(255,255,255,0.97)',
          backdropFilter: 'blur(8px)', display: 'flex', flexDirection: 'column',
          alignItems: 'center', paddingTop: 64, gap: 24, zIndex: 40,
        }}>
          {navLinks.map((link) => (
            <Link key={link.name} to={link.path} onClick={() => setIsOpen(false)} style={{
              fontSize: '1.125rem', letterSpacing: '0.05em', textDecoration: 'none',
              color: location.pathname === link.path ? '#0a0a0a' : '#737373',
              fontWeight: location.pathname === link.path ? 500 : 400,
            }}>
              {link.name}
            </Link>
          ))}
          <a href="/resume/Nikhil_Savita_Resume.pdf" target="_blank" rel="noopener noreferrer" style={{
            border: '1px solid #0a0a0a', background: '#0a0a0a', color: '#fafafa',
            padding: '10px 24px', fontSize: '0.75rem', fontWeight: 500,
            textTransform: 'uppercase', letterSpacing: '0.15em', textDecoration: 'none',
            marginTop: 16,
          }}>
            Resume
          </a>
        </div>
      )}
    </header>
  );
}
